import styled from 'styled-components'

const StyledPhotosView = styled.div``

export default StyledPhotosView
